<!-- =========================================================================================
File Name: PackageEditTabInformation.vue
Description: Package Edit Information Tab content
========================================================================================== -->
<template>
  <div id="package-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="PackageIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Informações sobre o <code>Pedido {{data_local.optional.number}}</code></span>
        </div>
        <!-- Col Content -->
        <div>
          <vs-input class="w-full mt-4" label="Transportadora" v-model="data_local.carrier.name" v-validate="'required'" name="name" />
          <span class="text-danger text-sm" v-show="errors.has('name')">Campo Obrigatório</span>
          <span class="text-description text-sm" v-show="!errors.has('name')">Para utilizar o SIGEP digite nesse campo <code>CORREIOS</code></span>
          <vx-tooltip title="Modalidades disponíveis no seu contrato" color="primary" :text="services">
            <vs-input class="w-full mt-4" label="Modalidade" v-model="data_local.carrier.kind" v-validate="'required'" name="kind" />
          </vx-tooltip>
          <span class="text-danger text-sm" v-show="errors.has('kind')">Campo Obrigatório</span>
          <vs-input class="w-full mt-4" label="Peso" v-model="data_local.attr.weight" v-validate="'required|decimal'" name="weight" />
          <span class="text-danger text-sm" v-show="errors.has('weight')">Campo Obrigatório. Somente números</span>
          <span class="text-description text-sm" v-show="!errors.has('weight')">Em Gramas. Somente números</span>
          <vs-input class="w-full mt-4" label="Altura" v-model="data_local.attr.height" v-validate="'required|decimal'" name="height" />
          <span class="text-danger text-sm" v-show="errors.has('height')">Campo Obrigatório. Somente números</span>
          <span class="text-description text-sm" v-show="!errors.has('height')">Em centímetros. Somente números</span>
          <vs-input class="w-full mt-4" label="Largura" v-model="data_local.attr.width" v-validate="'required|decimal'" name="width" />
          <span class="text-danger text-sm" v-show="errors.has('width')">Campo Obrigatório. Somente números</span>
          <span class="text-description text-sm" v-show="!errors.has('width')">Em centímetros. Somente números</span>
          <vs-input class="w-full mt-4" label="Profundidade" v-model="data_local.attr.length" v-validate="'required|decimal'" name="length" />
          <span class="text-danger text-sm" v-show="errors.has('length')">Campo Obrigatório. Somente números</span>
          <span class="text-description text-sm" v-show="!errors.has('length')">Em centímetros. Somente números</span>
          <vs-input class="w-full mt-4" label="Preço" v-model="data_local.attr.price" v-validate="'required|decimal'" name="price" />
          <span class="text-danger text-sm" v-show="errors.has('price')">Campo Obrigatório. Somente números</span>
          <span class="text-description text-sm" v-show="!errors.has('price')">Em centavos. Somente números</span>
          <vs-input class="w-full mt-4" label="Número NF se houver" v-model="data_local.optional.invoice" v-validate="'required|numeric'" name="invoice" />
          <span class="text-danger text-sm" v-show="errors.has('invoice')">Campo Obrigatório. Somente números</span>
          <span class="text-description text-sm" v-show="!errors.has('invoice')">Deixe como 0 caso não haja</span>
          <!-- <div class="mt-4">
<label class="text-sm">Currency</label>
<v-select v-model="data_local.attr.currency" :closeOnSelect="false" :options="currencyOptions" v-validate="'required'" name="currency" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
<span class="text-danger text-sm"  v-show="errors.has('currency')">Campo Obrigatório</span>
</div> -->
          <div class="mt-4">
            <label class="text-sm">Tipo do Envio</label>
            <div class="mt-2">
              <vs-radio v-model="data_local.attr.kind" vs-value="BOX" class="mr-4">PACOTE</vs-radio>
              <!-- <vs-radio v-model="data_local.attr.kind" vs-value="ENVELOPE" class="mr-4">ENVELOPE</vs-radio> -->
            </div>
          </div>
        </div>
      </div>
      <!-- Address Col -->
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end md:mt-0 mt-base">
          <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Endereço do Destinatário</span>
        </div>
        <!-- Col Content -->
        <div>
          
          <vs-input class="w-full mt-4" label="Nome Destinatário" data-vv-as="Nome Destinatário" v-model="data_local.destination.first_name" v-validate="{ required: true, regex:/^[0-9A-Za-záàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ ,.-_+=\/\()!@#$%]*$/ }" name="first_name" />
          <span class="text-danger text-sm" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>

          <vs-input class="w-full mt-4" label="Sobrenome Destinatário" data-vv-as="Sobrenome Destinatário" v-model="data_local.destination.last_name" v-validate="{ required: true, regex:/^[0-9A-Za-záàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ ,.-_+=\/\()!@#$%]*$/ }" name="last_name" />
          <span class="text-danger text-sm" v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>

          <vs-input class="w-full mt-4" label="Endereço" data-vv-as="Endereço" v-model="data_local.destination.address" v-validate="{ required: true, regex:/^[0-9A-Za-záàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ ,.-_+=\/\()!@#$%]*$/ }" name="address" />
          <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first('address') }}</span>
          
          <vs-input class="w-full mt-4" label="Número" data-vv-as="Número" v-model="data_local.destination.number" v-validate="'required|max:5'" name="number" />
          <span class="text-danger text-sm" v-show="errors.has('number')">{{ errors.first('number') }}</span>
          
          <vs-input class="w-full mt-4" label="Complemento" data-vv-as="Complemento" v-model="data_local.destination.complement" v-validate="{ regex:/^[0-9A-Za-záàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ ,.-_+=\/\()!@#$%]*$/ }" name="complement" />
          <span class="text-danger text-sm" v-show="errors.has('complement')">{{ errors.first('complement') }}</span>

          <vs-input class="w-full mt-4" label="CEP" data-vv-as="CEP" v-model="data_local.destination.zip_code" v-validate="'required|digits:8|numeric'" name="zip_code" />
          <span class="text-danger text-sm" v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>


          <vs-input class="w-full mt-4" label="Bairro" data-vv-as="Bairro" v-model="data_local.destination.region" v-validate="{ regex:/^[0-9A-Za-záàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ ,.-_+=\/\()!@#$%]*$/ }" name="region" />
          <span class="text-danger text-sm" v-show="errors.has('region')">{{ errors.first('region') }}</span>

          
          <vs-input class="w-full mt-4" label="Cidade" data-vv-as="Cidade" v-model="data_local.destination.city" v-validate="{ required: true, regex:/^[0-9A-Za-záàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ ,.-_+=\/\()!@#$%]*$/ }" name="city" />
          <span class="text-danger text-sm" v-show="errors.has('city')">{{ errors.first('city') }}</span>

          <vs-input class="w-full mt-4" label="Estado" data-vv-as="Estado" v-model="data_local.destination.state" v-validate="{ required: true, regex:/^[0-9A-Za-záàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ ,.-_+=\/\()!@#$%]*$/ }" name="state" />
          <span class="text-danger text-sm" v-show="errors.has('state')">{{ errors.first('state') }}</span>


          <!-- <vs-input class="w-full mt-4" label="Country" v-model="data_local.destination.country" v-validate="'required'" name="country" /> -->
          <!-- <span class="text-danger text-sm" v-show="errors.has('country')">Campo Obrigatório</span> -->
        </div>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Atualizar</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import flatPickr from 'vue-flatpickr-component'
//import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    // flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      data_local: JSON.parse(JSON.stringify(this.data)),

      currencyOptions: [
        { label: "BRL", value: "BRL" },
        { label: "USD", value: "USD" },
        { label: "INR", value: "INR" },
      ],
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    },
    info() {
      return this.$store.state.sigep.info;
    },
    services() {

      let result = '';

      // console.log({ info: this.$store.state.sigep.info });

      Object.entries(this.$store.state.sigep.info.services).forEach(entry => {
        let key = entry[0];
        let value = entry[1];

        console.log(`Tipo descrição ${typeof value}`)
        result += `(${key}) ${typeof value === 'string' || value instanceof String ? value : value.descricao}     `;

      });
      return result;
    }
  },
  methods: {
    save_changes() {

      // console.log('Save');

      return new Promise(() => {
        this.$validator.validateAll().then(result => {
          if (result) {

            this.$vs.loading();

            let pkg = {};
            let dest_temp = this.data_local.destination;
            this.data_local.attr.length = parseInt(this.data_local.attr.length);
            this.data_local.attr.height = parseInt(this.data_local.attr.height);
            this.data_local.attr.width = parseInt(this.data_local.attr.width);
            this.data_local.attr.weight = parseInt(this.data_local.attr.weight);
            this.data_local.attr.volume = parseInt(this.data_local.attr.volume);
            this.data_local.attr.price = parseInt(this.data_local.attr.price);
            delete dest_temp.valid;

            this.data_local.carrier.id_creds = this.info.id;
            pkg = { 'attr': this.data_local.attr, 'destination': dest_temp, 'carrier': this.data_local.carrier, 'optional': { invoice: Number(this.data_local.optional.invoice) } }

            let id = this.data_local.id;
            this.$store.dispatch("packageManagement/updateOrder", { id: id, packages: pkg })
              .then(res => {
                const carrier = res.data.tracking.carrier;
                const label_error = res.data.tracking.label_error;

                if (carrier == 'CORREIOS' && label_error == "") {

                  this.$vs.notify({
                    time: 20000,
                    title: 'Tudo ok!',
                    text: 'Pedido atualizado.',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                  })

                } else {

                  this.$vs.notify({
                    time: 20000,
                    title: 'Pedido atualizado, porém houve um <strong>erro</strong> na geração da etiqueta:',
                    text: `${label_error ? label_error : 'Endereço inválido: remova todos os caracteres que não sejam letras e números.'}`,
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                  })

                }

                this.$vs.loading.close();
              })
              .catch(err => {
                
                this.$vs.notify({
                  time: 20000,
                  title: 'Atenção',
                  text: `${err.response.data.message}`,
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })

                this.$vs.loading.close();

              })
            // if form have no errors

          }
        })
      })

    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    }
  },
}

</script>
